import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogAssistedBidAssignComponent, DialogAssistedBidAssignData } from './dialog-assisted-bid-assign.component';
import { DialogCutBidRequestComponent, DialogCutBidRequestData } from './dialog-cut-bid-request.component';
import { DialogStopAuctionComponent, DialogStopAuctionData } from './dialog-stop-auction.component';
import { DialogNotificationComponent } from './dialog-notification.component';
import { DialogSecurePhraseComponent } from './dialog-secure-phrase.component';
import { DialogYesNoComponent } from './dialog-yesno.component';

@Injectable()
export class DialogService {
  constructor(public dialog: MatDialog) {}

  get host() {
    return this.dialog;
  }

  askBinary(question: string) {
    return this.dialog.open(DialogYesNoComponent, {
      width: '450px',
      disableClose: true,
      data: { question },
    });
  }

  askStopAuction(data: DialogStopAuctionData) {
    return this.dialog.open(DialogStopAuctionComponent, {
      width: '550px',
      disableClose: true,
      data,
    });
  }

  askWithSecurePhrase(question: string, hint: string, securePhrase: string) {
    return this.dialog.open(DialogSecurePhraseComponent, {
      width: '450px',
      disableClose: true,
      data: { question, hint, securePhrase },
    });
  }

  showAssistedBidAssign(data: DialogAssistedBidAssignData) {
    return this.dialog.open(DialogAssistedBidAssignComponent, {
      width: '500px',
      maxWidth: '95vw',
      disableClose: false,
      data,
    });
  }

  showCutBidRequest(data: DialogCutBidRequestData) {
    return this.dialog.open(DialogCutBidRequestComponent, {
      width: '500px',
      disableClose: false,
      data: data,
    });
  }

  showNotificationDialog() {
    return this.dialog.open(DialogNotificationComponent, {
      width: '600px',
      disableClose: false
    });
  }
}
